import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../../../_globals';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-product-nutrition-form-dialog',
  templateUrl: './product-nutrition-form.component.html',
})
export class ProductNutritionFormComponent implements OnInit {
  @Input() product: any;

  constructor(public globals: Globals, public router: Router, public fb: FormBuilder) {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/forms/products/product-nutrition-form/product-nutrition-form.component.ts